
import Vue from "vue";
import { IBreadCrumbRoute } from "@/types/index";

export default Vue.extend({
  name: "bread-crumb",
  props: {
    routes: { type: [], default: Array<IBreadCrumbRoute>() },
  },
  mounted() {
    const content = document.getElementById("bcDivider");
    if (content) {
      const liItem = content.getElementsByTagName("li")[1];
      if (liItem) {
        liItem.setAttribute("aria-hidden", "true");
      }
      const liItem2 = content.getElementsByTagName("li")[3];
      if (liItem2) {
        liItem2.setAttribute("aria-hidden", "true");
      }
    }
  },
});
